export const categories = [
  {
    id: 'platform-news',
    name: '平台资讯',
    slug: 'platform-news',
    description: '众赢zygjb平台最新动态、版本更新、维护公告等官方资讯',
    icon: 'ri-newspaper-line',
    color: 'primary',
  },
  {
    id: 'game-guide',
    name: '游戏攻略',
    slug: 'game-guide',
    description: '精选游戏技巧、通关秘籍、高手心得分享',
    icon: 'ri-gamepad-line',
    color: 'accent',
  },
  {
    id: 'security',
    name: '安全指南',
    slug: 'security',
    description: '账号安全防护、防诈骗提醒、安全登录教程',
    icon: 'ri-shield-check-line',
    color: 'secondary',
  },
  {
    id: 'strategy',
    name: '实战策略',
    slug: 'strategy',
    description: '深度策略分析、数据研究、专业玩家经验分享',
    icon: 'ri-bar-chart-box-line',
    color: 'primary',
  },
  {
    id: 'faq-help',
    name: '常见问题',
    slug: 'faq-help',
    description: '平台使用指南、常见问题解答、客服帮助',
    icon: 'ri-question-answer-line',
    color: 'accent',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((c) => {
  categoryMap[c.slug] = c;
});